import * as actions from '../constants/actions';
import apiLatenciesReducer, { initialState as apiLatenciesInitialState } from './apiLatencies';
import speedTestReducer, { initialState as speedTestInitialState } from './speedTest';

const initialState = {
	enabled: true,
	includeMediaBoosters: false,
	apiLatencies: apiLatenciesInitialState,
	speedTest: speedTestInitialState,
	services: []
};

export default (state = initialState, action) => {
	const apiLatencies = apiLatenciesReducer(state.apiLatencies, action);
	const speedTest = speedTestReducer(state.speedTest, action);
	const newState = {
		...state,
		apiLatencies,
		speedTest
	};

	switch (action.type) {

		case actions.NETWORKHEALTH_ENABLED:
			return {
				...newState,
				enabled: action.payload
			};

		case actions.NETWORKHEALTH_INCLUDE_MEDIA_BOOSTERS:
			return {
				...newState,
				includeMediaBoosters: action.payload
			};

		case actions.NETWORKHEALTH_ADD_SERVICES:

			// Build deduped list of services
			let servicesMap = {};
			let services = [];
			state.services.concat(action.payload).forEach(service => {
				if (!servicesMap.hasOwnProperty(service.id)) {
					servicesMap[service.id] = true;
					services.push(service);
				}
			});

			return {
				...newState,
				services
			};

		case actions.NETWORKHEALTH_REMOVE_SERVICES: {
			const servicesToRemoveMap = action.payload.reduce((aggregator, service) => {
				return {
					...aggregator,
					[service.id]: true
				};
			}, {});
			const services = state.services.filter(service => {
				return !servicesToRemoveMap[service.id];
			});
			return {
				...newState,
				services
			};
		}

		default:
			return newState;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/networkHealth.js